module.exports = __webpack_public_path__ + "static/media/marker_region_vastmanland.d5ca2c4e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/markers/marker_region_vastmanland.svg
// module id = 290
// module chunks = 0